import { FormControlLabel } from "@mui/material";
import React from "react";
import { Controller, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CheckboxField } from "../../../../../shared/form/fields/basic/CheckboxField";
import { useValueChanges } from "../../../../../shared/hooks/basic/UseValueChanges";
import { useMachineStateSelector } from "../../../../../shared/hooks/useMachineStateSelector";
import { StyledRow } from "../../PromotionPage.styles";
import { usePromoStore } from "../../stores/PromoStore";
import { IFormValues } from "../../types";

export const LoyaltyPartnerField: React.FC = () => {
  const { t } = useTranslation("createPromo");
  const { machine } = usePromoStore();

  const state = useMachineStateSelector(machine.select((state) => {
    return { isReadonly: state.loyaltyPartner.isReadOnly };
  }));

  const loyaltyPartner = useWatch<IFormValues, "loyaltyPartner">({ name: "loyaltyPartner" });

  useValueChanges(loyaltyPartner, (value) => {
    machine.changeLoyaltyPartner(value);
  }, [ machine ]);

  return (
    <StyledRow>
      <Controller<IFormValues, "loyaltyPartner">
        name="loyaltyPartner"
        render={({ field }) => {
          return <FormControlLabel
            control={<CheckboxField readOnly={state.isReadonly} {...field} />}
            disabled={state.isReadonly}
            label={t("loyalty_partner")}
          />;
        }}
      />
    </StyledRow>
  );
};
